class Tariff {
    absence = '';
    billable = false;
    customerName = '';
    fixedHours = null;
    id = '';
    name = '';
    constructor(json) {
        if (json !== null) {
            try {
                this.absence = json.absence;
                this.billable = json.billable;
                this.customerName = json.customerName;
                this.fixedHours = json.fixedHours;
                this.id = json.id;
                this.name = json.name;
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/Tariff -> constructor');
            }
        }
    }
}
export default Tariff;
